import { render, staticRenderFns } from "./SignUpFree.vue?vue&type=template&id=6377d9cf&scoped=true&"
import script from "./SignUpFree.vue?vue&type=script&lang=js&"
export * from "./SignUpFree.vue?vue&type=script&lang=js&"
import style0 from "./SignUpFree.vue?vue&type=style&index=0&id=6377d9cf&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6377d9cf",
  null
  
)

export default component.exports